import React from "react";
import { motion } from "framer-motion";
import { InstagramLogo, YoutubeLogo, TiktokLogo, TwitterLogo, EnvelopeSimple } from "@phosphor-icons/react";

const socialLinks = [
  { icon: InstagramLogo, label: "Instagram", href: "#", testId: "social-instagram" },
  { icon: YoutubeLogo, label: "YouTube", href: "#", testId: "social-youtube" },
  { icon: TiktokLogo, label: "TikTok", href: "#", testId: "social-tiktok" },
  { icon: TwitterLogo, label: "Twitter", href: "#", testId: "social-twitter" },
  { icon: EnvelopeSimple, label: "Email", href: "mailto:hello@elev8fit.com", testId: "social-email" },
];

export default function Footer() {
  return (
    <footer
      id="footer"
      data-testid="footer-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
        >
          {/* Massive Logo */}
          <h2
            data-testid="footer-logo"
            className="font-['Barlow_Condensed'] text-6xl sm:text-8xl lg:text-[10rem] font-black uppercase tracking-tighter text-white/5 leading-none select-none mb-12"
          >
            ELEV<span className="text-[#FF3B30]/10">8</span>FIT
          </h2>

          {/* Social Icons */}
          <div className="flex items-center justify-center gap-6 mb-12">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                data-testid={link.testId}
                className="w-12 h-12 flex items-center justify-center border border-white/10 rounded-full text-white/40 hover:text-white hover:border-[#FF3B30] hover:bg-[#FF3B30]/10 transition-all duration-300"
                aria-label={link.label}
              >
                <link.icon size={22} weight="regular" />
              </a>
            ))}
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-8 mb-12">
            {["Media Kit", "Terms", "Privacy Policy"].map((link) => (
              <a
                key={link}
                href="#"
                className="text-sm text-white/30 hover:text-white/60 transition-colors uppercase tracking-wider"
              >
                {link}
              </a>
            ))}
          </div>

          {/* Copyright */}
          <p
            data-testid="footer-copyright"
            className="text-xs text-white/20 uppercase tracking-widest"
          >
            &copy; {new Date().getFullYear()} ELEV8FIT. All Rights Reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
